import { FormControl, Select, MenuItem, Dialog, CircularProgress } from '@material-ui/core';
import { useBank, bankDetailsInitState, BankDetailsType } from '../../../../hooks/useBank';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { useEffect, Dispatch, SetStateAction } from 'react';
import { maskAccountNo } from '../../../../utils/utilityFunctions';

type SelectBankProps = {
    folioNo: string;
    amc: string;
    handleBankDetails?: Dispatch<SetStateAction<BankDetailsType>>;
    redemptionFlag?:boolean;
};

export const SelectBank = ({ folioNo, amc, handleBankDetails, redemptionFlag=false }: SelectBankProps) => {
    const {
        portfolios: { data: portfolioData },
    } = useSelector(({ portfolio }: RootStateType) => ({
        ...portfolio,
    }));
    const [bankObjects, bankDetails, setBankDetails, loading] = useBank(
        portfolioData,
        folioNo,
        amc,
        redemptionFlag,
    );
    useEffect(() => {
        !!handleBankDetails ? handleBankDetails(bankDetails) : null;
    }, [bankDetails, folioNo]);
    return (
        <>
            <LoadingDialog open={loading} />
            {!!bankDetails && !!bankObjects && !loading && (
                <>
                    <FormControl variant="outlined" className="mf-investment-select">
                        <Select
                            labelId="bank-details"
                            id="portfolio-sortby"
                            value={bankDetails?.accountNo}
                            onChange={(e: any) => {
                                const currentBank =
                                    bankObjects.find(
                                        (bank: BankDetailsType) =>
                                            bank.accountNo === e.target.value,
                                    ) || bankDetailsInitState;
                                setBankDetails(currentBank);
                            }}
                        >
                            {bankObjects.map((bank: any) => {
                                return (
                                    !!bank?.accountNo && (
                                        <MenuItem value={bank.accountNo}>
                                           {!!bank?.name ? `${bank.name} - ${maskAccountNo(bank.accountNo)}` : `${maskAccountNo(bank.accountNo)}`}
                                        </MenuItem>
                                    )
                                );
                            })}
                        </Select>
                    </FormControl>
                </>
            )}
        </>
    );
};

const LoadingDialog = ({ open }: { open: boolean }) => {
    return (
        <Dialog maxWidth={'sm'} open={open} aria-labelledby="enable-fingerprint-modal">
            <div className="enable-fingerprint-modal">
                <CircularProgress />
                <p style={{ marginTop: '12px' }}>{'Fetching investor details...'}</p>
            </div>
        </Dialog>
    );
};
